import { Component, HostBinding } from '@angular/core';
import { ChangeCredentials, Login } from '@app/auth/actions/auth';
import * as fromAuth from '@app/auth/reducers';
import { AppInfo } from '@app/core/models/app-info';
import * as fromRoot from '@app/reducer';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'pcs-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {

  @HostBinding('class.d-flex') rootClasses = true;

  appInfo$: Observable<AppInfo> = this.store.pipe(select(fromRoot.getAppInfo));
  authError$: Observable<boolean> = this.store.pipe(select(fromAuth.getAuthError));

  constructor(private store: Store<fromAuth.State>) {
  }

  onSubmit(credentials) {
    this.store.dispatch(new Login(credentials));
  }

  onChange(){
    this.store.dispatch(new ChangeCredentials());
  }
}
